"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.oneOfProp = void 0;

var util_1 = require("../util");

var validators_1 = require("../validators"); // inspired by https://github.com/dwightjack/vue-types/blob/4.1.1/src/validators/oneof.ts


var getOneOfType = function getOneOfType(values) {
  var allowedTypes = _toConsumableArray(new Set(values.flatMap(function (value) {
    var _a;

    if (value === null || value === undefined) {
      return [];
    }

    return (// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      (_a = value.constructor) !== null && _a !== void 0 ? _a : []
    );
  })));

  if (allowedTypes.length === 0) {
    return undefined;
  }

  if (allowedTypes.length === 1) {
    return allowedTypes[0];
  }

  return allowedTypes;
};
/**
 * Allows any of the specified allowed values (validated at runtime and compile time).
 *
 * Type parameter `T` can be used to adjust the inferred type at compile time, this is usually not necessary.
 *
 * @param allowedValues - The allowed values.
 * @param validator - Optional function for further runtime validation; should return `undefined` if valid, or an error string if invalid.
 */


var oneOfProp = function oneOfProp(allowedValues, validator) {
  return (0, util_1.propOptionsGenerator)(getOneOfType(allowedValues), validator, (0, validators_1.isOneOf)(allowedValues));
};

exports.oneOfProp = oneOfProp;